import GetStartedContainer from './GetStarted.container';

export default GetStartedContainer;
